import { provideWidgetClass } from "scrivito"

export const UserDetailsWidget = provideWidgetClass("UserDetailsWidget", {
  attributes: {
    link: "link"
  }
})

export type UserDetailsWidgetInstance = InstanceType<typeof UserDetailsWidget>
